/**
 * Sysadmin Library — /sysadmin/library/folders redirect (Library-PR-X2).
 *
 * The pre-X2 Folders entity-tab (wiki folders) has been collapsed into
 * the unified Documents tab — wiki folders surface via the Folder filter
 * Select on the Documents page. This route 302-redirects to keep legacy
 * bookmarks working.
 *
 * Folder CRUD (create/rename/delete) currently lives behind the
 * folder Select; a dedicated "Manage folders" affordance is a Phase-5
 * follow-up if the founder asks for it. The tenant Library uses the
 * same pattern: folders are a sidebar concern, not a separate tab.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/library/folders')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/library/documents', replace: true });
  },
});
